import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, Container, Typography, CircularProgress, Alert } from '@mui/material';
import { orderApi } from '../services/api';

const Success: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    if (!sessionId) {
      setError('No session ID found');
      setLoading(false);
      return;
    }

    // Here you could verify the session status with your backend
    // For now, we'll just show a success message
    setLoading(false);
  }, [searchParams]);

  if (loading) {
    return (
      <Container maxWidth="sm">
        <Box sx={{ my: 4, textAlign: 'center' }}>
          <CircularProgress />
          <Typography variant="h6" sx={{ mt: 2 }}>
            Verifying your payment...
          </Typography>
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="sm">
        <Box sx={{ my: 4 }}>
          <Alert severity="error">{error}</Alert>
          <Typography variant="body1" sx={{ mt: 2 }}>
            Please try again or contact support if the problem persists.
          </Typography>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm">
      <Box sx={{ my: 4, textAlign: 'center' }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Thank you for your order!
        </Typography>
        <Typography variant="body1" paragraph>
          Your payment was successful and your postcard is being processed.
        </Typography>
        <Typography variant="body1" paragraph>
          We'll send you an email when your postcard is on its way.
        </Typography>
      </Box>
    </Container>
  );
};

export default Success; 